import React from 'react';
import { Box, Typography, Container, Grid, Card, CardContent, Button } from '@mui/material';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

const screenshots = [
  // Placeholder images, replace with real screenshots
  'https://via.placeholder.com/400x250?text=Screenshot+1',
  'https://via.placeholder.com/400x250?text=Screenshot+2',
  'https://via.placeholder.com/400x250?text=Screenshot+3',
];

const DemoPage = () => {
  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      py: 8,
      px: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Animated gradient circle */}
      <Box sx={{
        position: 'absolute',
        top: -120,
        right: -120,
        width: 320,
        height: 320,
        borderRadius: '50%',
        background: 'radial-gradient(circle at 30% 30%, #FE6B8B55 0%, #6e7eea00 80%)',
        zIndex: 0,
        filter: 'blur(8px)',
      }} />
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
        <Typography variant="h2" sx={{ color: '#fff', fontWeight: 900, mb: 2, textAlign: 'center', letterSpacing: 1 }}>
          Pathly Demo
        </Typography>
        <Typography variant="h5" sx={{ color: 'rgba(255,255,255,0.92)', mb: 6, textAlign: 'center', fontWeight: 400 }}>
          See Pathly in action! Explore our features through screenshots and a live demo video below.
        </Typography>
        {/* Demo Video Section */}
        <Card sx={{ mb: 8, borderRadius: 4, boxShadow: '0 8px 32px 0 rgba(110,126,234,0.18)', background: 'rgba(255,255,255,0.97)', p: 3 }}>
          <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Box sx={{ width: '100%', maxWidth: 640, aspectRatio: '16/9', mb: 2, borderRadius: 3, overflow: 'hidden', boxShadow: '0 4px 24px #6e7eea22' }}>
              {/* Demo video link updated to https://youtu.be/BQf6G9FM27U */}
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/BQf6G9FM27U"
                title="Pathly Demo Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ borderRadius: 12 }}
              />
            </Box>
            <Button
              variant="outlined"
              startIcon={<PlayCircleOutlineIcon />}
              href="https://youtu.be/BQf6G9FM27U"
              target="_blank"
              sx={{ fontWeight: 700, fontSize: 18, borderRadius: 99, px: 4, py: 1.5, mt: 1 }}
            >
              Watch Full Demo
            </Button>
          </CardContent>
        </Card>
        {/* Screenshots Section removed */}
      </Container>
    </Box>
  );
};

export default DemoPage; 